import { formatDistanceToNow, differenceInDays } from 'date-fns'

export const formatTimeAgo = (date: Date | string): string => {
  if (!date) {
    return 'Never'
  }

  const now = new Date()
  const targetDate = typeof date === 'string' ? new Date(date) : date
  const daysDifference = differenceInDays(now, targetDate)

  if (daysDifference < 1) {
    return formatDistanceToNow(targetDate, { addSuffix: true })
  } else if (daysDifference < 7) {
    return `${daysDifference}d ago`
  } else if (daysDifference < 30) {
    const weeks = Math.floor(daysDifference / 7)
    return `${weeks}w ago`
  } else if (daysDifference < 365) {
    const months = Math.floor(daysDifference / 30)
    return `${months}mo ago`
  } else {
    const years = Math.floor(daysDifference / 365)
    return `${years}y ago`
  }
}
